'use client';

import _defineProperty from "/codebuild/output/src3720/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3720/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "description", "error", "required", "classNames", "styles", "className", "unstyled", "__staticSelector", "__stylesApiProps", "errorProps", "labelProps", "descriptionProps", "wrapperProps", "id", "size", "style", "inputContainer", "inputWrapperOrder", "withAsterisk", "variant", "vars", "mod"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import 'react';
import 'react/jsx-runtime';
import '@mantine/hooks';
import 'clsx';
import '../../core/MantineProvider/Mantine.context.mjs';
import '../../core/MantineProvider/default-theme.mjs';
import '../../core/MantineProvider/MantineProvider.mjs';
import '../../core/MantineProvider/MantineThemeProvider/MantineThemeProvider.mjs';
import { useProps } from '../../core/MantineProvider/use-props/use-props.mjs';
import '../../core/MantineProvider/MantineCssVariables/MantineCssVariables.mjs';
import { extractStyleProps } from '../../core/Box/style-props/extract-style-props/extract-style-props.mjs';
import '../../core/Box/Box.mjs';
import '../../core/DirectionProvider/DirectionProvider.mjs';
function useInputProps(component, defaultProps, _props) {
  var props = useProps(component, defaultProps, _props);
  var label = props.label,
    description = props.description,
    error = props.error,
    required = props.required,
    classNames = props.classNames,
    styles = props.styles,
    className = props.className,
    unstyled = props.unstyled,
    __staticSelector = props.__staticSelector,
    __stylesApiProps = props.__stylesApiProps,
    errorProps = props.errorProps,
    labelProps = props.labelProps,
    descriptionProps = props.descriptionProps,
    _wrapperProps = props.wrapperProps,
    id = props.id,
    size = props.size,
    style = props.style,
    inputContainer = props.inputContainer,
    inputWrapperOrder = props.inputWrapperOrder,
    withAsterisk = props.withAsterisk,
    variant = props.variant,
    vars = props.vars,
    mod = props.mod,
    others = _objectWithoutProperties(props, _excluded);
  var _extractStyleProps = extractStyleProps(others),
    styleProps = _extractStyleProps.styleProps,
    rest = _extractStyleProps.rest;
  var wrapperProps = _objectSpread({
    label: label,
    description: description,
    error: error,
    required: required,
    classNames: classNames,
    className: className,
    __staticSelector: __staticSelector,
    __stylesApiProps: __stylesApiProps || props,
    errorProps: errorProps,
    labelProps: labelProps,
    descriptionProps: descriptionProps,
    unstyled: unstyled,
    styles: styles,
    size: size,
    style: style,
    inputContainer: inputContainer,
    inputWrapperOrder: inputWrapperOrder,
    withAsterisk: withAsterisk,
    variant: variant,
    id: id,
    mod: mod
  }, _wrapperProps);
  return _objectSpread(_objectSpread({}, rest), {}, {
    classNames: classNames,
    styles: styles,
    unstyled: unstyled,
    wrapperProps: _objectSpread(_objectSpread({}, wrapperProps), styleProps),
    inputProps: {
      required: required,
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      size: size,
      __staticSelector: __staticSelector,
      __stylesApiProps: __stylesApiProps || props,
      error: error,
      variant: variant,
      id: id
    }
  });
}
export { useInputProps };